import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const schema = yup
  .object({
    name: yup
      .string()
      .trim()
      .required()
      .min(1, 'Name must be at least 1 character')
      .label('Name'),
    icon: yup
      .object()
      .required()
      .nullable()
      .label('Icon'),
  })
  .required()

const resAddSection = yupResolver(schema)

export default resAddSection
